module.exports = __webpack_public_path__ + "img/icon-info.a2dd368e.svg";